import React from 'react'
import { MegaMenuItem } from '@/components/molecules/MegaMenuItem/MegaMenuItem'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { ReactComponent as Arrow } from '@/assets/icons/thin-arrow-purple.svg'

export function Integrations({ menu }: { menu: MegaMenu }) {
  return (
    <div
      key={menu._uid}
      className="p-24 netbook:p-24 lg:p-40 lg:pt-24 netbook:border-t-1 border-grey-100 grid grid-cols-1 netbook:grid-cols-2 grid-rows-[auto,1fr,auto] netbook:grid-rows-[1fr,auto] gap-16"
    >
      <p className="inline w-fit text-bodyS text-text-dark-900 font-bold capitalize">{menu.text}</p>
      {menu.link?.length > 0 && (
        <CustomLink
          {...menu.link[0]}
          className="flex netbook:place-content-end gap-4 items-center text-bodyS font-bold text-text-brand-darker hover:text-primary-500 [&>svg]:size-10"
        >
          {menu.link[0].text}
          <Arrow />
        </CustomLink>
      )}
      <ul className="grid grid-cols-2 gap-16 netbook:flex netbook:justify-between row-start-2 col-start-1">
        {menu.dropdown_menu?.map((item) => <MegaMenuItem key={item._uid} item={item} variant="integrations" />)}
      </ul>
    </div>
  )
}
